export default class ColumnDefinitionFactory {
  static create (columnDef) {
    if (columnDef.formatType) {
      return { ...columnDef, cellRendererFramework: 'AgGridCellFormatter' }
    } else if (columnDef.children) {
      return { ...columnDef, children: columnDef.children.map((child) => ColumnDefinitionFactory.create(child)) }
    } else {
      return columnDef
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/ColumnDefinitionFactory.js